<ll-titulo>{{ i18nKeyTitulo | t }}</ll-titulo>

<div class="tabs_content">
    <ayuda-list [targetApp]="targetApp"></ayuda-list>
</div>
